import React from 'react';
import PropTypes from 'prop-types';
import {ImpactMapList} from '../';

class StormReport extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'StormReport'
  }
  render() {
    const {
      F_Scale,
      Speed,
      Size,
      Time,
      Location,
      County,
      State,
      Comments,
      Lat,
      Lon,
    } = this.props.report;

    const iconClass = F_Scale || Speed ? 'wi-wind' : (
      Size ? 'wi-weather5' : 'wi-wind'
    );

    const styleType = F_Scale ? 'secondary' : (
      Size ? 'tertiary' : (
        Speed ? 'quartenary' : 'primary'
      )
    );
    const Info = ({amount, label, iconClass}) => {
      return <div className="info">
        <strong className="amount"><i className={iconClass}></i> {amount}</strong>
        <span className={`text-${styleType}`}>{label}</span>
      </div>
    }
    return (
      <div className={`panel`}>
        <div className={`panel-heading bg-${styleType}`}>
          <div className={`panel-heading-icon`}>
            <i className={iconClass}></i>
          </div>
        </div>
        <div className="panel-body">
          <div className="widget-summary widget-summary-md">
            {/*<div className="widget-summary-col widget-summary-col-icon">
                          <div className={`summary-icon bg-${styleType}`}>
                            <i className={iconClass}></i>
                          </div>
                        </div>*/}
            <div className="widget-summary-col">
              <div className="summary">
                <h4 className="title">Storm Report</h4>
                {F_Scale ? <Info amount={F_Scale} iconClass="wi-wind" label="Scale Tornado" /> : '' }
                {Speed ? <Info amount={Speed} iconClass="wi-wind" label="mph Wind" /> : '' }
                {Size ? <Info amount={Size} iconClass="wi-weather5" label="'' Hail" /> : ''}
                {Time ? <Info amount={Time} iconClass="fa fa-time" label="Time" /> : ''}
                <hr className="dotted short" />
                <ul className="list-unstyled">
                  <li>County: {County}</li>
                  <li>State: {State}</li>
                </ul>
                {Comments ? (
                  <div>
                    <hr className="dotted short" />
                    <h4 className="text-muted">Comments</h4>
                    <p>{Comments}</p>
                  </div>
                ) : ''}
                <ImpactMapList coords={{lat: Lat, lng: Lon}} />
              </div>
              {/*<div className="summary-footer">
                              <a className="text-muted text-uppercase">(view all)</a>
                            </div>*/}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

StormReport.propTypes = {
  report : PropTypes.object.isRequired,
  // iconClass : PropTypes.object.isRequired,
  // styleType : PropTypes.oneOf(["primary", "secondary", "tertiary", "quartenary"]),
}

export default StormReport;



// WEBPACK FOOTER //
// ./src/browser/components/maps/storm-report.js